// src/config/borerEnvironmentConfig.js
// A URL da API é lida de REACT_APP_BORER_API_URL no .env.
// Os valores abaixo servem como fallback caso a variável não esteja definida.

export const BORER_ENVIRONMENTS = {
  desenvolvimento: {
    label: 'Desenvolvimento',
    apiBaseUrl: 'https://api-borer-dev.azurewebsites.net',
    available: true,
  },
  staging: {
    label: 'Staging',
    apiBaseUrl: 'https://api-borer-stg.azurewebsites.net',
    available: false,
  },
  producao: {
    label: 'Produção',
    apiBaseUrl: 'https://api-borer.agroverita.com.br',
    available: false,
  },
};

let currentBorerEnvironment = process.env.REACT_APP_ENVIRONMENT || 'desenvolvimento';

export function getCurrentBorerEnvironment() {
  return currentBorerEnvironment;
}

export function setCurrentBorerEnvironment(env) {
  if (!BORER_ENVIRONMENTS[env]) throw new Error(`Ambiente inválido: ${env}`);
  currentBorerEnvironment = env;
}

export function getCurrentBorerConfig() {
  const config = BORER_ENVIRONMENTS[currentBorerEnvironment];
  return {
    ...config,
    apiBaseUrl: process.env.REACT_APP_BORER_API_URL || config.apiBaseUrl,
  };
}
